// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file enums.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file enums.proto.
 */
export const file_enums: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from enum raccoonai.TruckStatus
 */
export enum TruckStatus {
  /**
   * @generated from enum value: TRUCK_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: TRUCK_STATUS_INACTIVE = 1;
   */
  INACTIVE = 1,

  /**
   * @generated from enum value: TRUCK_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: TRUCK_STATUS_IN_REPAIR = 3;
   */
  IN_REPAIR = 3,

  /**
   * @generated from enum value: TRUCK_STATUS_GUEST = 4;
   */
  GUEST = 4,
}

/**
 * @generated from enum raccoonai.TruckStatus
 */
export type TruckStatusJson = "TRUCK_STATUS_UNDEFINED" | "TRUCK_STATUS_INACTIVE" | "TRUCK_STATUS_ACTIVE" | "TRUCK_STATUS_IN_REPAIR" | "TRUCK_STATUS_GUEST";

/**
 * Describes the enum raccoonai.TruckStatus.
 */
export const TruckStatusSchema: GenEnum<TruckStatus, TruckStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 0);

/**
 * @generated from enum raccoonai.TruckType
 */
export enum TruckType {
  /**
   * @generated from enum value: TRUCK_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: TRUCK_TYPE_CONSTRUCTION = 1;
   */
  CONSTRUCTION = 1,

  /**
   * multilift
   *
   * @generated from enum value: TRUCK_TYPE_DOUBLE_CONTAINER = 2;
   */
  DOUBLE_CONTAINER = 2,

  /**
   * @generated from enum value: TRUCK_TYPE_MSW = 3;
   */
  MSW = 3,

  /**
   * samosval
   *
   * @generated from enum value: TRUCK_TYPE_TIPPER = 4;
   */
  TIPPER = 4,

  /**
   * @generated from enum value: TRUCK_TYPE_LIQUID_WASTE = 5;
   */
  LIQUID_WASTE = 5,

  /**
   * КМУ, кран-манипулятор
   *
   * @generated from enum value: TRUCK_TYPE_LOADER_CRANE = 6;
   */
  LOADER_CRANE = 6,
}

/**
 * @generated from enum raccoonai.TruckType
 */
export type TruckTypeJson = "TRUCK_TYPE_UNDEFINED" | "TRUCK_TYPE_CONSTRUCTION" | "TRUCK_TYPE_DOUBLE_CONTAINER" | "TRUCK_TYPE_MSW" | "TRUCK_TYPE_TIPPER" | "TRUCK_TYPE_LIQUID_WASTE" | "TRUCK_TYPE_LOADER_CRANE";

/**
 * Describes the enum raccoonai.TruckType.
 */
export const TruckTypeSchema: GenEnum<TruckType, TruckTypeJson> = /*@__PURE__*/
  enumDesc(file_enums, 1);

/**
 * @generated from enum raccoonai.TruckLoadType
 */
export enum TruckLoadType {
  /**
   * @generated from enum value: TRUCK_LOAD_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: TRUCK_LOAD_TYPE_FRONT = 1;
   */
  FRONT = 1,

  /**
   * @generated from enum value: TRUCK_LOAD_TYPE_BACK = 2;
   */
  BACK = 2,

  /**
   * @generated from enum value: TRUCK_LOAD_TYPE_SIDE = 3;
   */
  SIDE = 3,

  /**
   * @generated from enum value: TRUCK_LOAD_TYPE_TOP = 4;
   */
  TOP = 4,
}

/**
 * @generated from enum raccoonai.TruckLoadType
 */
export type TruckLoadTypeJson = "TRUCK_LOAD_TYPE_UNDEFINED" | "TRUCK_LOAD_TYPE_FRONT" | "TRUCK_LOAD_TYPE_BACK" | "TRUCK_LOAD_TYPE_SIDE" | "TRUCK_LOAD_TYPE_TOP";

/**
 * Describes the enum raccoonai.TruckLoadType.
 */
export const TruckLoadTypeSchema: GenEnum<TruckLoadType, TruckLoadTypeJson> = /*@__PURE__*/
  enumDesc(file_enums, 2);

/**
 * @generated from enum raccoonai.TruckStandard
 */
export enum TruckStandard {
  /**
   * @generated from enum value: TRUCK_STANDARD_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: TRUCK_STANDARD_EURO_1 = 1;
   */
  EURO_1 = 1,

  /**
   * @generated from enum value: TRUCK_STANDARD_EURO_2 = 2;
   */
  EURO_2 = 2,

  /**
   * @generated from enum value: TRUCK_STANDARD_EURO_3 = 3;
   */
  EURO_3 = 3,

  /**
   * @generated from enum value: TRUCK_STANDARD_EURO_4 = 4;
   */
  EURO_4 = 4,

  /**
   * @generated from enum value: TRUCK_STANDARD_EURO_5 = 5;
   */
  EURO_5 = 5,

  /**
   * @generated from enum value: TRUCK_STANDARD_EURO_6 = 6;
   */
  EURO_6 = 6,

  /**
   * @generated from enum value: TRUCK_STANDARD_EURO_7 = 7;
   */
  EURO_7 = 7,
}

/**
 * @generated from enum raccoonai.TruckStandard
 */
export type TruckStandardJson = "TRUCK_STANDARD_UNDEFINED" | "TRUCK_STANDARD_EURO_1" | "TRUCK_STANDARD_EURO_2" | "TRUCK_STANDARD_EURO_3" | "TRUCK_STANDARD_EURO_4" | "TRUCK_STANDARD_EURO_5" | "TRUCK_STANDARD_EURO_6" | "TRUCK_STANDARD_EURO_7";

/**
 * Describes the enum raccoonai.TruckStandard.
 */
export const TruckStandardSchema: GenEnum<TruckStandard, TruckStandardJson> = /*@__PURE__*/
  enumDesc(file_enums, 3);

/**
 * @generated from enum raccoonai.JobType
 */
export enum JobType {
  /**
   * @generated from enum value: JOB_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   *  Core Bunker Operations
   *
   * Забрать с заменой [to be deprecated??]
   *
   * @generated from enum value: JOB_TYPE_SERVICE = 1;
   */
  SERVICE = 1,

  /**
   * Забрать с заменой
   *
   * @generated from enum value: JOB_TYPE_REPLACE_BUNKER = 2;
   */
  REPLACE_BUNKER = 2,

  /**
   * Установить ёмкость
   *
   * @generated from enum value: JOB_TYPE_ADD_BUNKER = 3;
   */
  ADD_BUNKER = 3,

  /**
   * Забрать без замены
   *
   * @generated from enum value: JOB_TYPE_REMOVE_BUNKER = 4;
   */
  REMOVE_BUNKER = 4,

  /**
   * Municipal Solid Waste
   *
   * Municipal Solid Waste
   *
   * @generated from enum value: JOB_TYPE_MSW = 10;
   */
  MSW = 10,

  /**
   * Подбор (Standard site cleanup)
   *
   * @generated from enum value: JOB_TYPE_MSW_CLEANUP = 20;
   */
  MSW_CLEANUP = 20,

  /**
   * Подбор с объездом на ходу
   *
   * @generated from enum value: JOB_TYPE_MSW_MOBILE_CLEANUP = 21;
   */
  MSW_MOBILE_CLEANUP = 21,

  /**
   *  Sanitation
   *
   * Дезинфекция
   *
   * @generated from enum value: JOB_TYPE_DISINFECTION = 22;
   */
  DISINFECTION = 22,

  /**
   *  Logistics
   *
   * Перевозка
   *
   * @generated from enum value: JOB_TYPE_TRANSPORTATION = 30;
   */
  TRANSPORTATION = 30,

  /**
   * Перевозка (МПС - МПС)
   *
   * @generated from enum value: JOB_TYPE_TRANSPORTATION_MPS = 31;
   */
  TRANSPORTATION_MPS = 31,

  /**
   * Miscellaneous
   *
   * Брендировать ёмкость
   *
   * @generated from enum value: JOB_TYPE_BRAND_CONTAINER = 40;
   */
  BRAND_CONTAINER = 40,

  /**
   * Ремонт ёмкости
   *
   * @generated from enum value: JOB_TYPE_REPAIR_CONTAINER = 41;
   */
  REPAIR_CONTAINER = 41,

  /**
   * Снять ёмкость
   *
   * @generated from enum value: JOB_TYPE_DECOMMISSION_CONTAINER = 42;
   */
  DECOMMISSION_CONTAINER = 42,

  /**
   * Установить крышку
   *
   * @generated from enum value: JOB_TYPE_INSTALL_LID = 43;
   */
  INSTALL_LID = 43,

  /**
   * Снять крышку
   *
   * @generated from enum value: JOB_TYPE_REMOVE_LID = 44;
   */
  REMOVE_LID = 44,

  /**
   * Установить идентификатор
   *
   * @generated from enum value: JOB_TYPE_INSTALL_TAG = 45;
   */
  INSTALL_TAG = 45,

  /**
   * Liquid Waste
   *
   * Liquid Waste
   *
   * @generated from enum value: JOB_TYPE_LIQUID_WASTE = 50;
   */
  LIQUID_WASTE = 50,

  /**
   * Multilift
   *
   * @generated from enum value: JOB_TYPE_DOUBLE_CONSTRUCTION_REPLACE_BUNKER = 60;
   */
  DOUBLE_CONSTRUCTION_REPLACE_BUNKER = 60,

  /**
   * @generated from enum value: JOB_TYPE_DOUBLE_CONSTRUCTION_ADD_BUNKER = 61;
   */
  DOUBLE_CONSTRUCTION_ADD_BUNKER = 61,

  /**
   * @generated from enum value: JOB_TYPE_DOUBLE_CONSTRUCTION_REMOVE_BUNKER = 62;
   */
  DOUBLE_CONSTRUCTION_REMOVE_BUNKER = 62,

  /**
   * Bulk haul: a tipper sent alongside a loader crane takes what the crane loads
   *
   * Приём груза (самосвал)
   *
   * @generated from enum value: JOB_TYPE_RECEIVE_LOAD = 70;
   */
  RECEIVE_LOAD = 70,
}

/**
 * @generated from enum raccoonai.JobType
 */
export type JobTypeJson = "JOB_TYPE_UNDEFINED" | "JOB_TYPE_SERVICE" | "JOB_TYPE_REPLACE_BUNKER" | "JOB_TYPE_ADD_BUNKER" | "JOB_TYPE_REMOVE_BUNKER" | "JOB_TYPE_MSW" | "JOB_TYPE_MSW_CLEANUP" | "JOB_TYPE_MSW_MOBILE_CLEANUP" | "JOB_TYPE_DISINFECTION" | "JOB_TYPE_TRANSPORTATION" | "JOB_TYPE_TRANSPORTATION_MPS" | "JOB_TYPE_BRAND_CONTAINER" | "JOB_TYPE_REPAIR_CONTAINER" | "JOB_TYPE_DECOMMISSION_CONTAINER" | "JOB_TYPE_INSTALL_LID" | "JOB_TYPE_REMOVE_LID" | "JOB_TYPE_INSTALL_TAG" | "JOB_TYPE_LIQUID_WASTE" | "JOB_TYPE_DOUBLE_CONSTRUCTION_REPLACE_BUNKER" | "JOB_TYPE_DOUBLE_CONSTRUCTION_ADD_BUNKER" | "JOB_TYPE_DOUBLE_CONSTRUCTION_REMOVE_BUNKER" | "JOB_TYPE_RECEIVE_LOAD";

/**
 * Describes the enum raccoonai.JobType.
 */
export const JobTypeSchema: GenEnum<JobType, JobTypeJson> = /*@__PURE__*/
  enumDesc(file_enums, 4);

/**
 * JobMetric selects which per-day job series GetJobMetricSeries returns.
 *
 * @generated from enum raccoonai.JobMetric
 */
export enum JobMetric {
  /**
   * @generated from enum value: JOB_METRIC_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * SUM(job_tariff) of completed jobs, bucketed by completion day
   *
   * @generated from enum value: JOB_METRIC_REVENUE = 1;
   */
  REVENUE = 1,

  /**
   * COUNT of non-cancelled jobs, bucketed by created day
   *
   * @generated from enum value: JOB_METRIC_ORDERED = 2;
   */
  ORDERED = 2,

  /**
   * COUNT of completed jobs, bucketed by completion day
   *
   * @generated from enum value: JOB_METRIC_COMPLETED = 3;
   */
  COMPLETED = 3,
}

/**
 * JobMetric selects which per-day job series GetJobMetricSeries returns.
 *
 * @generated from enum raccoonai.JobMetric
 */
export type JobMetricJson = "JOB_METRIC_UNDEFINED" | "JOB_METRIC_REVENUE" | "JOB_METRIC_ORDERED" | "JOB_METRIC_COMPLETED";

/**
 * Describes the enum raccoonai.JobMetric.
 */
export const JobMetricSchema: GenEnum<JobMetric, JobMetricJson> = /*@__PURE__*/
  enumDesc(file_enums, 5);

/**
 * JobTotal keys a job list's "totals" facet: not a breakdown but what every job the
 * request matches adds up to — all of them, not one page; under one_per_order, each
 * order once. Facet counts are whole numbers, hence volume in litres.
 *
 * @generated from enum raccoonai.JobTotal
 */
export enum JobTotal {
  /**
   * @generated from enum value: JOB_TOTAL_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * Orders: jobs sharing an order_number are one; a job without one is its own.
   *
   * @generated from enum value: JOB_TOTAL_ORDERS = 1;
   */
  ORDERS = 1,

  /**
   * @generated from enum value: JOB_TOTAL_PICKUP_LOCATIONS = 2;
   */
  PICKUP_LOCATIONS = 2,

  /**
   * Planned containers: a job's own count, else its container group's.
   *
   * @generated from enum value: JOB_TOTAL_CONTAINERS = 3;
   */
  CONTAINERS = 3,

  /**
   * Planned volume, in litres (m³ × 1000, rounded): those containers × the volume of
   * their container group's type.
   *
   * @generated from enum value: JOB_TOTAL_VOLUME_LITRES = 4;
   */
  VOLUME_LITRES = 4,
}

/**
 * JobTotal keys a job list's "totals" facet: not a breakdown but what every job the
 * request matches adds up to — all of them, not one page; under one_per_order, each
 * order once. Facet counts are whole numbers, hence volume in litres.
 *
 * @generated from enum raccoonai.JobTotal
 */
export type JobTotalJson = "JOB_TOTAL_UNDEFINED" | "JOB_TOTAL_ORDERS" | "JOB_TOTAL_PICKUP_LOCATIONS" | "JOB_TOTAL_CONTAINERS" | "JOB_TOTAL_VOLUME_LITRES";

/**
 * Describes the enum raccoonai.JobTotal.
 */
export const JobTotalSchema: GenEnum<JobTotal, JobTotalJson> = /*@__PURE__*/
  enumDesc(file_enums, 6);

/**
 * @generated from enum raccoonai.DriverMetric
 */
export enum DriverMetric {
  /**
   * @generated from enum value: DRIVER_METRIC_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: DRIVER_METRIC_SHIFTS_COMPLETED = 1;
   */
  SHIFTS_COMPLETED = 1,

  /**
   * @generated from enum value: DRIVER_METRIC_ROUTES_COMPLETED = 2;
   */
  ROUTES_COMPLETED = 2,

  /**
   * @generated from enum value: DRIVER_METRIC_REWARD = 3;
   */
  REWARD = 3,
}

/**
 * @generated from enum raccoonai.DriverMetric
 */
export type DriverMetricJson = "DRIVER_METRIC_UNDEFINED" | "DRIVER_METRIC_SHIFTS_COMPLETED" | "DRIVER_METRIC_ROUTES_COMPLETED" | "DRIVER_METRIC_REWARD";

/**
 * Describes the enum raccoonai.DriverMetric.
 */
export const DriverMetricSchema: GenEnum<DriverMetric, DriverMetricJson> = /*@__PURE__*/
  enumDesc(file_enums, 7);

/**
 * @generated from enum raccoonai.JobCategory
 */
export enum JobCategory {
  /**
   * @generated from enum value: JOB_CATEGORY_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: JOB_CATEGORY_CO = 1;
   */
  CO = 1,

  /**
   * @generated from enum value: JOB_CATEGORY_MSW = 2;
   */
  MSW = 2,

  /**
   * @generated from enum value: JOB_CATEGORY_LIQUID = 3;
   */
  LIQUID = 3,

  /**
   * @generated from enum value: JOB_CATEGORY_DISINFECTION = 4;
   */
  DISINFECTION = 4,

  /**
   * @generated from enum value: JOB_CATEGORY_TIPPER = 5;
   */
  TIPPER = 5,
}

/**
 * @generated from enum raccoonai.JobCategory
 */
export type JobCategoryJson = "JOB_CATEGORY_UNDEFINED" | "JOB_CATEGORY_CO" | "JOB_CATEGORY_MSW" | "JOB_CATEGORY_LIQUID" | "JOB_CATEGORY_DISINFECTION" | "JOB_CATEGORY_TIPPER";

/**
 * Describes the enum raccoonai.JobCategory.
 */
export const JobCategorySchema: GenEnum<JobCategory, JobCategoryJson> = /*@__PURE__*/
  enumDesc(file_enums, 8);

/**
 * @generated from enum raccoonai.JobStatus
 */
export enum JobStatus {
  /**
   * Default value, should not be used.
   *
   * @generated from enum value: JOB_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * Marks jobs that are created but have not yet been assigned to any drivers.
   *
   * @generated from enum value: JOB_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * Jobs that are assigned to drivers but have not yet going to the pickup location.
   *
   * @generated from enum value: JOB_STATUS_ASSIGNED = 2;
   */
  ASSIGNED = 2,

  /**
   * Jobs that are assigned to drivers and are currently en-route to the pickup location.
   *
   * @generated from enum value: JOB_STATUS_ENROUTE = 3;
   */
  ENROUTE = 3,

  /**
   * Marks jobs that are completed by the driver.
   *
   * @generated from enum value: JOB_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * Marks jobs that are cancelled by the dispatcher or client due to various reasons.
   *
   * @generated from enum value: JOB_STATUS_CANCELLED = 5;
   */
  CANCELLED = 5,

  /**
   * Marks jobs that are currently being performed by the driver.
   *
   * @generated from enum value: JOB_STATUS_ON_SERVICE = 6;
   */
  ON_SERVICE = 6,

  /**
   * Marks jobs that are force completed by dispatcher or system due to various reasons (e.g. driver
   * unable to complete the job due to safety issue, but the job is still considered completed for
   * record keeping and billing purposes).
   *
   * @generated from enum value: JOB_STATUS_FORCE_COMPLETED = 7;
   */
  FORCE_COMPLETED = 7,

  /**
   * Marks jobs that are could not be completed due to various reasons (e.g. truck is full, pickup
   * location is blocked). Jobs with this status are not considered completed, but the system will
   * automatically create a new job with the same details (i.e. pickup_location, order_number) for
   * someone to attempt again.
   *
   * @generated from enum value: JOB_STATUS_NOT_COMPLETED = 8;
   */
  NOT_COMPLETED = 8,
}

/**
 * @generated from enum raccoonai.JobStatus
 */
export type JobStatusJson = "JOB_STATUS_UNDEFINED" | "JOB_STATUS_CREATED" | "JOB_STATUS_ASSIGNED" | "JOB_STATUS_ENROUTE" | "JOB_STATUS_COMPLETED" | "JOB_STATUS_CANCELLED" | "JOB_STATUS_ON_SERVICE" | "JOB_STATUS_FORCE_COMPLETED" | "JOB_STATUS_NOT_COMPLETED";

/**
 * Describes the enum raccoonai.JobStatus.
 */
export const JobStatusSchema: GenEnum<JobStatus, JobStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 9);

/**
 * @generated from enum raccoonai.DispatcherReviewStatus
 */
export enum DispatcherReviewStatus {
  /**
   * @generated from enum value: DISPATCHER_REVIEW_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: DISPATCHER_REVIEW_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: DISPATCHER_REVIEW_STATUS_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * @generated from enum value: DISPATCHER_REVIEW_STATUS_REJECTED = 3;
   */
  REJECTED = 3,

  /**
   * @generated from enum value: DISPATCHER_REVIEW_STATUS_SUSPICIOUS = 4;
   */
  SUSPICIOUS = 4,
}

/**
 * @generated from enum raccoonai.DispatcherReviewStatus
 */
export type DispatcherReviewStatusJson = "DISPATCHER_REVIEW_STATUS_UNDEFINED" | "DISPATCHER_REVIEW_STATUS_PENDING" | "DISPATCHER_REVIEW_STATUS_APPROVED" | "DISPATCHER_REVIEW_STATUS_REJECTED" | "DISPATCHER_REVIEW_STATUS_SUSPICIOUS";

/**
 * Describes the enum raccoonai.DispatcherReviewStatus.
 */
export const DispatcherReviewStatusSchema: GenEnum<DispatcherReviewStatus, DispatcherReviewStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 10);

/**
 * @generated from enum raccoonai.JobEvent
 */
export enum JobEvent {
  /**
   * @generated from enum value: JOB_EVENT_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: JOB_EVENT_CREATE_JOB = 1;
   */
  CREATE_JOB = 1,

  /**
   * @generated from enum value: JOB_EVENT_ASSIGN = 2;
   */
  ASSIGN = 2,

  /**
   * @generated from enum value: JOB_EVENT_FALLBACK_ASSIGN = 3;
   */
  FALLBACK_ASSIGN = 3,

  /**
   * @generated from enum value: JOB_EVENT_ENROUTE = 4;
   */
  ENROUTE = 4,

  /**
   * @generated from enum value: JOB_EVENT_START_SERVICE = 5;
   */
  START_SERVICE = 5,

  /**
   * @generated from enum value: JOB_EVENT_COMPLETE = 6;
   */
  COMPLETE = 6,

  /**
   * @generated from enum value: JOB_EVENT_CANCEL = 7;
   */
  CANCEL = 7,

  /**
   * @generated from enum value: JOB_EVENT_DETACH_FROM_ROUTE = 8;
   */
  DETACH_FROM_ROUTE = 8,

  /**
   * @generated from enum value: JOB_EVENT_FORCE_COMPLETE = 9;
   */
  FORCE_COMPLETE = 9,
}

/**
 * @generated from enum raccoonai.JobEvent
 */
export type JobEventJson = "JOB_EVENT_UNDEFINED" | "JOB_EVENT_CREATE_JOB" | "JOB_EVENT_ASSIGN" | "JOB_EVENT_FALLBACK_ASSIGN" | "JOB_EVENT_ENROUTE" | "JOB_EVENT_START_SERVICE" | "JOB_EVENT_COMPLETE" | "JOB_EVENT_CANCEL" | "JOB_EVENT_DETACH_FROM_ROUTE" | "JOB_EVENT_FORCE_COMPLETE";

/**
 * Describes the enum raccoonai.JobEvent.
 */
export const JobEventSchema: GenEnum<JobEvent, JobEventJson> = /*@__PURE__*/
  enumDesc(file_enums, 11);

/**
 * @generated from enum raccoonai.RouteStatus
 */
export enum RouteStatus {
  /**
   * Default value, should not be used.
   *
   * @generated from enum value: ROUTE_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * Marks routes that are created, assigned to driver, but have not yet been started by the driver.
   *
   * @generated from enum value: ROUTE_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * Driver has started the route, but has not yet completed all jobs in the route.
   *
   * @generated from enum value: ROUTE_STATUS_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * Driver has started the route and is currently en-route back to the depot.
   * If all jobs are completed, the route will automatically switch to RETURNING status.
   * If some jobs in the route are not completed due to various reasons (e.g. truck is full,
   * pickup location is blocked). Not completed jobs will be marked as NOT_COMPLETED,
   * which consequently trigger to create new jobs with same order information.
   *
   * @generated from enum value: ROUTE_STATUS_RETURNING = 3;
   */
  RETURNING = 3,

  /**
   * Marks routes that are completed by the driver when arriving at the depot.
   *
   * @generated from enum value: ROUTE_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * Jobs that are not completed will be marked as CANCELLED, but jobs that are already
   * completed will remain COMPLETED
   *
   * @generated from enum value: ROUTE_STATUS_CANCELLED = 5;
   */
  CANCELLED = 5,

  /**
   * Marks all jobs in the route as FORCE_COMPLETED, regardless of their individual statuses.
   * Can be done only by dispatcher.
   *
   * @generated from enum value: ROUTE_STATUS_FORCE_COMPLETED = 6;
   */
  FORCE_COMPLETED = 6,

  /**
   * Marks Planned Routes for drivers but not Approved, can not be triggered by driver
   *
   * @generated from enum value: ROUTE_STATUS_NOT_APPROVED = 7;
   */
  NOT_APPROVED = 7,
}

/**
 * @generated from enum raccoonai.RouteStatus
 */
export type RouteStatusJson = "ROUTE_STATUS_UNDEFINED" | "ROUTE_STATUS_CREATED" | "ROUTE_STATUS_IN_PROGRESS" | "ROUTE_STATUS_RETURNING" | "ROUTE_STATUS_COMPLETED" | "ROUTE_STATUS_CANCELLED" | "ROUTE_STATUS_FORCE_COMPLETED" | "ROUTE_STATUS_NOT_APPROVED";

/**
 * Describes the enum raccoonai.RouteStatus.
 */
export const RouteStatusSchema: GenEnum<RouteStatus, RouteStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 12);

/**
 * @generated from enum raccoonai.RouteCategory
 */
export enum RouteCategory {
  /**
   * @generated from enum value: ROUTE_CATEGORY_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: ROUTE_CATEGORY_CO = 1;
   */
  CO = 1,

  /**
   * @generated from enum value: ROUTE_CATEGORY_MSW = 2;
   */
  MSW = 2,

  /**
   * @generated from enum value: ROUTE_CATEGORY_LIQUID = 3;
   */
  LIQUID = 3,

  /**
   * @generated from enum value: ROUTE_CATEGORY_TIPPER = 4;
   */
  TIPPER = 4,

  /**
   * @generated from enum value: ROUTE_CATEGORY_DISINFECTION = 5;
   */
  DISINFECTION = 5,
}

/**
 * @generated from enum raccoonai.RouteCategory
 */
export type RouteCategoryJson = "ROUTE_CATEGORY_UNDEFINED" | "ROUTE_CATEGORY_CO" | "ROUTE_CATEGORY_MSW" | "ROUTE_CATEGORY_LIQUID" | "ROUTE_CATEGORY_TIPPER" | "ROUTE_CATEGORY_DISINFECTION";

/**
 * Describes the enum raccoonai.RouteCategory.
 */
export const RouteCategorySchema: GenEnum<RouteCategory, RouteCategoryJson> = /*@__PURE__*/
  enumDesc(file_enums, 13);

/**
 * @generated from enum raccoonai.RouteEvent
 */
export enum RouteEvent {
  /**
   * @generated from enum value: ROUTE_EVENT_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: ROUTE_EVENT_CREATE_ROUTE = 1;
   */
  CREATE_ROUTE = 1,

  /**
   * @generated from enum value: ROUTE_EVENT_START = 2;
   */
  START = 2,

  /**
   * @generated from enum value: ROUTE_EVENT_RETURN_BACK = 3;
   */
  RETURN_BACK = 3,

  /**
   * @generated from enum value: ROUTE_EVENT_COMPLETE = 4;
   */
  COMPLETE = 4,

  /**
   * @generated from enum value: ROUTE_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS = 5;
   */
  CANCEL_ROUTE_DUE_RECEIVER_REASONS = 5,

  /**
   * @generated from enum value: ROUTE_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS = 6;
   */
  CANCEL_ROUTE_DUE_PROVIDER_REASONS = 6,

  /**
   * @generated from enum value: ROUTE_EVENT_FORCE_COMPLETE = 7;
   */
  FORCE_COMPLETE = 7,

  /**
   * @generated from enum value: ROUTE_EVENT_CREATE_ROUTE_BY_AI = 8;
   */
  CREATE_ROUTE_BY_AI = 8,

  /**
   * @generated from enum value: ROUTE_EVENT_UPDATE_JOBS = 9;
   */
  UPDATE_JOBS = 9,
}

/**
 * @generated from enum raccoonai.RouteEvent
 */
export type RouteEventJson = "ROUTE_EVENT_UNDEFINED" | "ROUTE_EVENT_CREATE_ROUTE" | "ROUTE_EVENT_START" | "ROUTE_EVENT_RETURN_BACK" | "ROUTE_EVENT_COMPLETE" | "ROUTE_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS" | "ROUTE_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS" | "ROUTE_EVENT_FORCE_COMPLETE" | "ROUTE_EVENT_CREATE_ROUTE_BY_AI" | "ROUTE_EVENT_UPDATE_JOBS";

/**
 * Describes the enum raccoonai.RouteEvent.
 */
export const RouteEventSchema: GenEnum<RouteEvent, RouteEventJson> = /*@__PURE__*/
  enumDesc(file_enums, 14);

/**
 * @generated from enum raccoonai.DriverOnShiftStatus
 */
export enum DriverOnShiftStatus {
  /**
   * @generated from enum value: DRIVER_ON_SHIFT_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * To be deprecated
   *
   * @generated from enum value: DRIVER_ON_SHIFT_STATUS_TRUCK_IDLE = 1;
   */
  TRUCK_IDLE = 1,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_STATUS_DRIVER_IDLE = 2;
   */
  DRIVER_IDLE = 2,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_STATUS_CONFIRMATION = 3;
   */
  CONFIRMATION = 3,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_STATUS_ENROUTE = 4;
   */
  ENROUTE = 4,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_STATUS_ON_SERVICE = 5;
   */
  ON_SERVICE = 5,

  /**
   * Driver is on shift but has not yet started any route,
   * and is waiting for dispatcher's assignment.
   *
   * @generated from enum value: DRIVER_ON_SHIFT_STATUS_IDLE = 10;
   */
  IDLE = 10,

  /**
   * Driver is on shift and currently performing a route
   * assigned by dispatcher.
   *
   * @generated from enum value: DRIVER_ON_SHIFT_STATUS_ACTIVE = 11;
   */
  ACTIVE = 11,

  /**
   * Shift is ended, either by driver or dispatcher. Driver
   * is off shift and is not available for assignment.
   *
   * @generated from enum value: DRIVER_ON_SHIFT_STATUS_ENDED = 12;
   */
  ENDED = 12,

  /**
   * Unapproved Shift for driver, only to be approved by dispatcher
   *
   * @generated from enum value: DRIVER_ON_SHIFT_STATUS_NOT_APPROVED = 13;
   */
  NOT_APPROVED = 13,

  /**
   * Shift was called off by a dispatcher before any work happened, as opposed
   * to ENDED, which is a shift that ran and finished.
   *
   * @generated from enum value: DRIVER_ON_SHIFT_STATUS_CANCELLED = 14;
   */
  CANCELLED = 14,
}

/**
 * @generated from enum raccoonai.DriverOnShiftStatus
 */
export type DriverOnShiftStatusJson = "DRIVER_ON_SHIFT_STATUS_UNDEFINED" | "DRIVER_ON_SHIFT_STATUS_TRUCK_IDLE" | "DRIVER_ON_SHIFT_STATUS_DRIVER_IDLE" | "DRIVER_ON_SHIFT_STATUS_CONFIRMATION" | "DRIVER_ON_SHIFT_STATUS_ENROUTE" | "DRIVER_ON_SHIFT_STATUS_ON_SERVICE" | "DRIVER_ON_SHIFT_STATUS_IDLE" | "DRIVER_ON_SHIFT_STATUS_ACTIVE" | "DRIVER_ON_SHIFT_STATUS_ENDED" | "DRIVER_ON_SHIFT_STATUS_NOT_APPROVED" | "DRIVER_ON_SHIFT_STATUS_CANCELLED";

/**
 * Describes the enum raccoonai.DriverOnShiftStatus.
 */
export const DriverOnShiftStatusSchema: GenEnum<DriverOnShiftStatus, DriverOnShiftStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 15);

/**
 * Derived state of one cell in the driver shift schedule matrix
 * (ShiftPlanService.ListShiftSchedule). Computed server-side by merging
 * shift_plan and driver_on_shift for an Asia/Almaty calendar day; a
 * driver_on_shift record always wins over a plan for the same day.
 *
 * @generated from enum raccoonai.ShiftCellState
 */
export enum ShiftCellState {
  /**
   * @generated from enum value: SHIFT_CELL_STATE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * Dark grey: driver_on_shift exists with status ENDED.
   *
   * @generated from enum value: SHIFT_CELL_STATE_ENDED = 1;
   */
  ENDED = 1,

  /**
   * Green: driver_on_shift exists with status ACTIVE (stale past
   * ACTIVE shifts intentionally stay green so dispatchers spot them).
   *
   * @generated from enum value: SHIFT_CELL_STATE_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * Dark blue: driver_on_shift exists but work has not started
   * (NOT_APPROVED or IDLE), day is today or later.
   *
   * @generated from enum value: SHIFT_CELL_STATE_NOT_STARTED = 3;
   */
  NOT_STARTED = 3,

  /**
   * Light blue: shift_plan exists, no driver_on_shift, day is today or later.
   *
   * @generated from enum value: SHIFT_CELL_STATE_PLANNED = 4;
   */
  PLANNED = 4,

  /**
   * Red: the day has passed and the driver never worked it — either a
   * shift_plan with no driver_on_shift, or a driver_on_shift that was never
   * started (NOT_APPROVED/IDLE). A no-show either way.
   * A DAY_OFF plan is never MISSED: not working was the plan.
   *
   * @generated from enum value: SHIFT_CELL_STATE_MISSED = 5;
   */
  MISSED = 5,
}

/**
 * Derived state of one cell in the driver shift schedule matrix
 * (ShiftPlanService.ListShiftSchedule). Computed server-side by merging
 * shift_plan and driver_on_shift for an Asia/Almaty calendar day; a
 * driver_on_shift record always wins over a plan for the same day.
 *
 * @generated from enum raccoonai.ShiftCellState
 */
export type ShiftCellStateJson = "SHIFT_CELL_STATE_UNDEFINED" | "SHIFT_CELL_STATE_ENDED" | "SHIFT_CELL_STATE_ACTIVE" | "SHIFT_CELL_STATE_NOT_STARTED" | "SHIFT_CELL_STATE_PLANNED" | "SHIFT_CELL_STATE_MISSED";

/**
 * Describes the enum raccoonai.ShiftCellState.
 */
export const ShiftCellStateSchema: GenEnum<ShiftCellState, ShiftCellStateJson> = /*@__PURE__*/
  enumDesc(file_enums, 16);

/**
 * What a shift_plan row plans for; SHIFT_CELL_STATE stays the derived state.
 *
 * @generated from enum raccoonai.ShiftPlanType
 */
export enum ShiftPlanType {
  /**
   * @generated from enum value: SHIFT_PLAN_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: SHIFT_PLAN_TYPE_DAY = 1;
   */
  DAY = 1,

  /**
   * @generated from enum value: SHIFT_PLAN_TYPE_NIGHT = 2;
   */
  NIGHT = 2,

  /**
   * @generated from enum value: SHIFT_PLAN_TYPE_DAY_OFF = 3;
   */
  DAY_OFF = 3,
}

/**
 * What a shift_plan row plans for; SHIFT_CELL_STATE stays the derived state.
 *
 * @generated from enum raccoonai.ShiftPlanType
 */
export type ShiftPlanTypeJson = "SHIFT_PLAN_TYPE_UNDEFINED" | "SHIFT_PLAN_TYPE_DAY" | "SHIFT_PLAN_TYPE_NIGHT" | "SHIFT_PLAN_TYPE_DAY_OFF";

/**
 * Describes the enum raccoonai.ShiftPlanType.
 */
export const ShiftPlanTypeSchema: GenEnum<ShiftPlanType, ShiftPlanTypeJson> = /*@__PURE__*/
  enumDesc(file_enums, 17);

/**
 * To be deprecated
 *
 * @generated from enum raccoonai.DriverOnShiftEvent
 */
export enum DriverOnShiftEvent {
  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_CREATE_SHIFT = 1;
   */
  CREATE_SHIFT = 1,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_DRIVER_ONLINE = 2;
   */
  DRIVER_ONLINE = 2,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_DRIVER_OFFLINE = 3;
   */
  DRIVER_OFFLINE = 3,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_CONFIRMATION = 4;
   */
  CONFIRMATION = 4,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_START_ROUTE = 5;
   */
  START_ROUTE = 5,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_START_SERVICE = 6;
   */
  START_SERVICE = 6,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_END_SERVICE = 7;
   */
  END_SERVICE = 7,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_COMPLETE_ROUTE = 8;
   */
  COMPLETE_ROUTE = 8,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS = 9;
   */
  CANCEL_ROUTE_DUE_RECEIVER_REASONS = 9,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS = 10;
   */
  CANCEL_ROUTE_DUE_PROVIDER_REASONS = 10,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_COMPLETE_SHIFT = 11;
   */
  COMPLETE_SHIFT = 11,

  /**
   * @generated from enum value: DRIVER_ON_SHIFT_EVENT_FORCE_COMPLETE_ROUTE = 12;
   */
  FORCE_COMPLETE_ROUTE = 12,
}

/**
 * To be deprecated
 *
 * @generated from enum raccoonai.DriverOnShiftEvent
 */
export type DriverOnShiftEventJson = "DRIVER_ON_SHIFT_EVENT_UNDEFINED" | "DRIVER_ON_SHIFT_EVENT_CREATE_SHIFT" | "DRIVER_ON_SHIFT_EVENT_DRIVER_ONLINE" | "DRIVER_ON_SHIFT_EVENT_DRIVER_OFFLINE" | "DRIVER_ON_SHIFT_EVENT_CONFIRMATION" | "DRIVER_ON_SHIFT_EVENT_START_ROUTE" | "DRIVER_ON_SHIFT_EVENT_START_SERVICE" | "DRIVER_ON_SHIFT_EVENT_END_SERVICE" | "DRIVER_ON_SHIFT_EVENT_COMPLETE_ROUTE" | "DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_RECEIVER_REASONS" | "DRIVER_ON_SHIFT_EVENT_CANCEL_ROUTE_DUE_PROVIDER_REASONS" | "DRIVER_ON_SHIFT_EVENT_COMPLETE_SHIFT" | "DRIVER_ON_SHIFT_EVENT_FORCE_COMPLETE_ROUTE";

/**
 * Describes the enum raccoonai.DriverOnShiftEvent.
 */
export const DriverOnShiftEventSchema: GenEnum<DriverOnShiftEvent, DriverOnShiftEventJson> = /*@__PURE__*/
  enumDesc(file_enums, 18);

/**
 * @generated from enum raccoonai.OrganizationStatus
 */
export enum OrganizationStatus {
  /**
   * @generated from enum value: ORGANIZATION_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: ORGANIZATION_STATUS_INACTIVE = 1;
   */
  INACTIVE = 1,

  /**
   * @generated from enum value: ORGANIZATION_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: ORGANIZATION_STATUS_GUEST = 3;
   */
  GUEST = 3,
}

/**
 * @generated from enum raccoonai.OrganizationStatus
 */
export type OrganizationStatusJson = "ORGANIZATION_STATUS_UNDEFINED" | "ORGANIZATION_STATUS_INACTIVE" | "ORGANIZATION_STATUS_ACTIVE" | "ORGANIZATION_STATUS_GUEST";

/**
 * Describes the enum raccoonai.OrganizationStatus.
 */
export const OrganizationStatusSchema: GenEnum<OrganizationStatus, OrganizationStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 19);

/**
 * @generated from enum raccoonai.OrganizationType
 */
export enum OrganizationType {
  /**
   * @generated from enum value: ORGANIZATION_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: ORGANIZATION_TYPE_RACCOONAI = 1;
   */
  RACCOONAI = 1,

  /**
   * @generated from enum value: ORGANIZATION_TYPE_SERVICE_PROVIDER = 2;
   */
  SERVICE_PROVIDER = 2,

  /**
   * @generated from enum value: ORGANIZATION_TYPE_SERVICE_RECEIVER = 3;
   */
  SERVICE_RECEIVER = 3,

  /**
   * @generated from enum value: ORGANIZATION_TYPE_DISPOSAL_SITE_OPERATOR = 4;
   */
  DISPOSAL_SITE_OPERATOR = 4,

  /**
   * @generated from enum value: ORGANIZATION_TYPE_GOVERNMENT = 5;
   */
  GOVERNMENT = 5,
}

/**
 * @generated from enum raccoonai.OrganizationType
 */
export type OrganizationTypeJson = "ORGANIZATION_TYPE_UNDEFINED" | "ORGANIZATION_TYPE_RACCOONAI" | "ORGANIZATION_TYPE_SERVICE_PROVIDER" | "ORGANIZATION_TYPE_SERVICE_RECEIVER" | "ORGANIZATION_TYPE_DISPOSAL_SITE_OPERATOR" | "ORGANIZATION_TYPE_GOVERNMENT";

/**
 * Describes the enum raccoonai.OrganizationType.
 */
export const OrganizationTypeSchema: GenEnum<OrganizationType, OrganizationTypeJson> = /*@__PURE__*/
  enumDesc(file_enums, 20);

/**
 * @generated from enum raccoonai.UserRole
 */
export enum UserRole {
  /**
   * @generated from enum value: USER_ROLE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: USER_ROLE_ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * @generated from enum value: USER_ROLE_RECEIVER_USER = 2;
   */
  RECEIVER_USER = 2,

  /**
   * @generated from enum value: USER_ROLE_DRIVER = 3;
   */
  DRIVER = 3,

  /**
   * @generated from enum value: USER_ROLE_PROVIDER_DISPATCHER = 4;
   */
  PROVIDER_DISPATCHER = 4,

  /**
   * @generated from enum value: USER_ROLE_SUPPORT = 6;
   */
  SUPPORT = 6,

  /**
   * @generated from enum value: USER_ROLE_PROVIDER_OWNER = 7;
   */
  PROVIDER_OWNER = 7,

  /**
   * @generated from enum value: USER_ROLE_DISPOSAL_SITE_OWNER = 8;
   */
  DISPOSAL_SITE_OWNER = 8,

  /**
   * @generated from enum value: USER_ROLE_DISPOSAL_SITE_ECO_INSPECTOR = 9;
   */
  DISPOSAL_SITE_ECO_INSPECTOR = 9,

  /**
   * @generated from enum value: USER_ROLE_GOVERNMENT_AUDITOR = 10;
   */
  GOVERNMENT_AUDITOR = 10,

  /**
   * @generated from enum value: USER_ROLE_PROVIDER_MECHANIC = 11;
   */
  PROVIDER_MECHANIC = 11,

  /**
   * @generated from enum value: USER_ROLE_GPS_INNER_SERVICE = 12;
   */
  GPS_INNER_SERVICE = 12,

  /**
   * @generated from enum value: USER_ROLE_PROVIDER_OWNER_VIEW_ONLY = 13;
   */
  PROVIDER_OWNER_VIEW_ONLY = 13,

  /**
   * @generated from enum value: USER_ROLE_PROVIDER_SALES = 14;
   */
  PROVIDER_SALES = 14,

  /**
   * Government ecology officer who logs and reviews field situation reports
   * (GovSituationReportService). Distinct from the government auditor role.
   *
   * @generated from enum value: USER_ROLE_GOVERNMENT_ECO = 15;
   */
  GOVERNMENT_ECO = 15,

  /**
   * @generated from enum value: USER_ROLE_GOVERNMENT_AUDITOR_EDITOR = 16;
   */
  GOVERNMENT_AUDITOR_EDITOR = 16,

  /**
   * @generated from enum value: USER_ROLE_PROVIDER_LOADER = 17;
   */
  PROVIDER_LOADER = 17,

  /**
   * RaccoonAI's own dispatcher, dispatching on behalf of service-provider
   * companies that outsource dispatching to us (DaaS). Internal role.
   *
   * @generated from enum value: USER_ROLE_DAAS_DISPATCHER = 18;
   */
  DAAS_DISPATCHER = 18,

  /**
   * Technical user of a service provider's accounting system (1C). May call
   * Integration1CService only; its owner organization must be a service provider.
   *
   * @generated from enum value: USER_ROLE_INTEGRATION_1C = 19;
   */
  INTEGRATION_1C = 19,
}

/**
 * @generated from enum raccoonai.UserRole
 */
export type UserRoleJson = "USER_ROLE_UNDEFINED" | "USER_ROLE_ADMIN" | "USER_ROLE_RECEIVER_USER" | "USER_ROLE_DRIVER" | "USER_ROLE_PROVIDER_DISPATCHER" | "USER_ROLE_SUPPORT" | "USER_ROLE_PROVIDER_OWNER" | "USER_ROLE_DISPOSAL_SITE_OWNER" | "USER_ROLE_DISPOSAL_SITE_ECO_INSPECTOR" | "USER_ROLE_GOVERNMENT_AUDITOR" | "USER_ROLE_PROVIDER_MECHANIC" | "USER_ROLE_GPS_INNER_SERVICE" | "USER_ROLE_PROVIDER_OWNER_VIEW_ONLY" | "USER_ROLE_PROVIDER_SALES" | "USER_ROLE_GOVERNMENT_ECO" | "USER_ROLE_GOVERNMENT_AUDITOR_EDITOR" | "USER_ROLE_PROVIDER_LOADER" | "USER_ROLE_DAAS_DISPATCHER" | "USER_ROLE_INTEGRATION_1C";

/**
 * Describes the enum raccoonai.UserRole.
 */
export const UserRoleSchema: GenEnum<UserRole, UserRoleJson> = /*@__PURE__*/
  enumDesc(file_enums, 21);

/**
 * @generated from enum raccoonai.UserStatus
 */
export enum UserStatus {
  /**
   * @generated from enum value: USER_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: USER_STATUS_INACTIVE = 1;
   */
  INACTIVE = 1,

  /**
   * @generated from enum value: USER_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: USER_STATUS_GUEST = 3;
   */
  GUEST = 3,
}

/**
 * @generated from enum raccoonai.UserStatus
 */
export type UserStatusJson = "USER_STATUS_UNDEFINED" | "USER_STATUS_INACTIVE" | "USER_STATUS_ACTIVE" | "USER_STATUS_GUEST";

/**
 * Describes the enum raccoonai.UserStatus.
 */
export const UserStatusSchema: GenEnum<UserStatus, UserStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 22);

/**
 * @generated from enum raccoonai.ContractStatus
 */
export enum ContractStatus {
  /**
   * @generated from enum value: CONTRACT_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: CONTRACT_STATUS_INACTIVE = 1;
   */
  INACTIVE = 1,

  /**
   * @generated from enum value: CONTRACT_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: CONTRACT_STATUS_HIDDEN = 3;
   */
  HIDDEN = 3,
}

/**
 * @generated from enum raccoonai.ContractStatus
 */
export type ContractStatusJson = "CONTRACT_STATUS_UNDEFINED" | "CONTRACT_STATUS_INACTIVE" | "CONTRACT_STATUS_ACTIVE" | "CONTRACT_STATUS_HIDDEN";

/**
 * Describes the enum raccoonai.ContractStatus.
 */
export const ContractStatusSchema: GenEnum<ContractStatus, ContractStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 23);

/**
 * @generated from enum raccoonai.ContractType
 */
export enum ContractType {
  /**
   * @generated from enum value: CONTRACT_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: CONTRACT_TYPE_WASTE_OPERATOR = 1;
   */
  WASTE_OPERATOR = 1,

  /**
   * @generated from enum value: CONTRACT_TYPE_WASTE_POLYGON = 2;
   */
  WASTE_POLYGON = 2,

  /**
   * «По норме»: the client uses someone else's pickup location, orders nothing,
   * and pays a flat monthly_fee. Prices no job types.
   *
   * @generated from enum value: CONTRACT_TYPE_BY_NORM = 3;
   */
  BY_NORM = 3,
}

/**
 * @generated from enum raccoonai.ContractType
 */
export type ContractTypeJson = "CONTRACT_TYPE_UNDEFINED" | "CONTRACT_TYPE_WASTE_OPERATOR" | "CONTRACT_TYPE_WASTE_POLYGON" | "CONTRACT_TYPE_BY_NORM";

/**
 * Describes the enum raccoonai.ContractType.
 */
export const ContractTypeSchema: GenEnum<ContractType, ContractTypeJson> = /*@__PURE__*/
  enumDesc(file_enums, 24);

/**
 * @generated from enum raccoonai.LocationStatus
 */
export enum LocationStatus {
  /**
   * @generated from enum value: LOCATION_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: LOCATION_STATUS_INACTIVE = 1;
   */
  INACTIVE = 1,

  /**
   * @generated from enum value: LOCATION_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,
}

/**
 * @generated from enum raccoonai.LocationStatus
 */
export type LocationStatusJson = "LOCATION_STATUS_UNDEFINED" | "LOCATION_STATUS_INACTIVE" | "LOCATION_STATUS_ACTIVE";

/**
 * Describes the enum raccoonai.LocationStatus.
 */
export const LocationStatusSchema: GenEnum<LocationStatus, LocationStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 25);

/**
 * @generated from enum raccoonai.LocationType
 */
export enum LocationType {
  /**
   * @generated from enum value: LOCATION_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: LOCATION_TYPE_DEPOT = 1;
   */
  DEPOT = 1,

  /**
   * @generated from enum value: LOCATION_TYPE_DISPOSAL_SITE = 2;
   */
  DISPOSAL_SITE = 2,

  /**
   * @generated from enum value: LOCATION_TYPE_GAS_STATION = 3;
   */
  GAS_STATION = 3,

  /**
   * @generated from enum value: LOCATION_TYPE_SUSPICIOUS = 4;
   */
  SUSPICIOUS = 4,

  /**
   * Waste Sorting Complex
   *
   * @generated from enum value: LOCATION_TYPE_SORTING_COMPLEX = 5;
   */
  SORTING_COMPLEX = 5,

  /**
   * Waste Processing Plant
   *
   * @generated from enum value: LOCATION_TYPE_PROCESSING_PLANT = 6;
   */
  PROCESSING_PLANT = 6,

  /**
   * Waste Transfer Station
   *
   * @generated from enum value: LOCATION_TYPE_TRANSFER_STATION = 7;
   */
  TRANSFER_STATION = 7,
}

/**
 * @generated from enum raccoonai.LocationType
 */
export type LocationTypeJson = "LOCATION_TYPE_UNDEFINED" | "LOCATION_TYPE_DEPOT" | "LOCATION_TYPE_DISPOSAL_SITE" | "LOCATION_TYPE_GAS_STATION" | "LOCATION_TYPE_SUSPICIOUS" | "LOCATION_TYPE_SORTING_COMPLEX" | "LOCATION_TYPE_PROCESSING_PLANT" | "LOCATION_TYPE_TRANSFER_STATION";

/**
 * Describes the enum raccoonai.LocationType.
 */
export const LocationTypeSchema: GenEnum<LocationType, LocationTypeJson> = /*@__PURE__*/
  enumDesc(file_enums, 26);

/**
 * @generated from enum raccoonai.PickupLocationType
 */
export enum PickupLocationType {
  /**
   * @generated from enum value: PICKUP_LOCATION_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: PICKUP_LOCATION_TYPE_CONSTRUCTION = 1;
   */
  CONSTRUCTION = 1,

  /**
   * @generated from enum value: PICKUP_LOCATION_TYPE_HOUSEHOLD = 2;
   */
  HOUSEHOLD = 2,

  /**
   * @generated from enum value: PICKUP_LOCATION_TYPE_SEPTIC = 3;
   */
  SEPTIC = 3,

  /**
   * @generated from enum value: PICKUP_LOCATION_TYPE_MULTILIFT = 4;
   */
  MULTILIFT = 4,
}

/**
 * @generated from enum raccoonai.PickupLocationType
 */
export type PickupLocationTypeJson = "PICKUP_LOCATION_TYPE_UNDEFINED" | "PICKUP_LOCATION_TYPE_CONSTRUCTION" | "PICKUP_LOCATION_TYPE_HOUSEHOLD" | "PICKUP_LOCATION_TYPE_SEPTIC" | "PICKUP_LOCATION_TYPE_MULTILIFT";

/**
 * Describes the enum raccoonai.PickupLocationType.
 */
export const PickupLocationTypeSchema: GenEnum<PickupLocationType, PickupLocationTypeJson> = /*@__PURE__*/
  enumDesc(file_enums, 27);

/**
 * @generated from enum raccoonai.PickupLocationPriority
 */
export enum PickupLocationPriority {
  /**
   * @generated from enum value: PICKUP_LOCATION_PRIORITY_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: PICKUP_LOCATION_PRIORITY_LOW = 1;
   */
  LOW = 1,

  /**
   * @generated from enum value: PICKUP_LOCATION_PRIORITY_MEDIUM = 2;
   */
  MEDIUM = 2,

  /**
   * @generated from enum value: PICKUP_LOCATION_PRIORITY_HIGH = 3;
   */
  HIGH = 3,
}

/**
 * @generated from enum raccoonai.PickupLocationPriority
 */
export type PickupLocationPriorityJson = "PICKUP_LOCATION_PRIORITY_UNDEFINED" | "PICKUP_LOCATION_PRIORITY_LOW" | "PICKUP_LOCATION_PRIORITY_MEDIUM" | "PICKUP_LOCATION_PRIORITY_HIGH";

/**
 * Describes the enum raccoonai.PickupLocationPriority.
 */
export const PickupLocationPrioritySchema: GenEnum<PickupLocationPriority, PickupLocationPriorityJson> = /*@__PURE__*/
  enumDesc(file_enums, 28);

/**
 * @generated from enum raccoonai.ContainerTypeStatus
 */
export enum ContainerTypeStatus {
  /**
   * @generated from enum value: CONTAINER_TYPE_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * Hidden from pickers for new container groups/containers; existing ones keep it.
   *
   * @generated from enum value: CONTAINER_TYPE_STATUS_INACTIVE = 1;
   */
  INACTIVE = 1,

  /**
   * @generated from enum value: CONTAINER_TYPE_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,
}

/**
 * @generated from enum raccoonai.ContainerTypeStatus
 */
export type ContainerTypeStatusJson = "CONTAINER_TYPE_STATUS_UNDEFINED" | "CONTAINER_TYPE_STATUS_INACTIVE" | "CONTAINER_TYPE_STATUS_ACTIVE";

/**
 * Describes the enum raccoonai.ContainerTypeStatus.
 */
export const ContainerTypeStatusSchema: GenEnum<ContainerTypeStatus, ContainerTypeStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 29);

/**
 * @generated from enum raccoonai.WasteType
 */
export enum WasteType {
  /**
   * @generated from enum value: WASTE_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * СО
   *
   * @generated from enum value: WASTE_TYPE_CONSTRUCTION = 1;
   */
  CONSTRUCTION = 1,

  /**
   * Municipal Solid Waste - ТБО
   *
   * @generated from enum value: WASTE_TYPE_MSW = 2;
   */
  MSW = 2,

  /**
   * @generated from enum value: WASTE_TYPE_LIQUID = 3;
   */
  LIQUID = 3,

  /**
   * @generated from enum value: WASTE_TYPE_ORGANIC = 4;
   */
  ORGANIC = 4,

  /**
   * ПНД - полиэтилена низкого давления
   *
   * @generated from enum value: WASTE_TYPE_LOW_DENSITY_POLYETHYLENE = 5;
   */
  LOW_DENSITY_POLYETHYLENE = 5,

  /**
   * КГМ - крупногабаритный мусор
   *
   * @generated from enum value: WASTE_TYPE_BULKY = 6;
   */
  BULKY = 6,

  /**
   * Балласт
   *
   * @generated from enum value: WASTE_TYPE_BALLAST = 7;
   */
  BALLAST = 7,

  /**
   * Негабарит
   *
   * @generated from enum value: WASTE_TYPE_OVERSIZED = 8;
   */
  OVERSIZED = 8,

  /**
   * Отходы микс
   *
   * @generated from enum value: WASTE_TYPE_MIXED = 9;
   */
  MIXED = 9,

  /**
   * Целлофан
   *
   * @generated from enum value: WASTE_TYPE_CELLOPHANE = 10;
   */
  CELLOPHANE = 10,

  /**
   * Стеклобой
   *
   * @generated from enum value: WASTE_TYPE_GLASS_CULLET = 11;
   */
  GLASS_CULLET = 11,

  /**
   * Мед и био отходы
   *
   * @generated from enum value: WASTE_TYPE_MEDICAL_AND_BIO = 12;
   */
  MEDICAL_AND_BIO = 12,

  /**
   * Алюминиевые банки
   *
   * @generated from enum value: WASTE_TYPE_ALUMINUM_CANS = 13;
   */
  ALUMINUM_CANS = 13,

  /**
   * Флейки
   *
   * @generated from enum value: WASTE_TYPE_FLAKES = 14;
   */
  FLAKES = 14,

  /**
   * Polyethylene Terephthalate - ПЭТ
   *
   * @generated from enum value: WASTE_TYPE_PET = 15;
   */
  PET = 15,

  /**
   * Fuel and lubricants - ГСМ
   *
   * @generated from enum value: WASTE_TYPE_PETRO_PRODUCTS = 16;
   */
  PETRO_PRODUCTS = 16,

  /**
   * Хвосты
   *
   * @generated from enum value: WASTE_TYPE_PRESSED_MSW = 17;
   */
  PRESSED_MSW = 17,

  /**
   * Хвосты росыпь - Not Pressed, but sorted
   *
   * @generated from enum value: WASTE_TYPE_SORTED_MSW = 18;
   */
  SORTED_MSW = 18,

  /**
   * Хвосты росыпь 1 - Not Pressed and not sorted, due to overload
   *
   * @generated from enum value: WASTE_TYPE_NOT_SORTED_MSW = 19;
   */
  NOT_SORTED_MSW = 19,

  /**
   * Септик | Ассенизатор
   *
   * @generated from enum value: WASTE_TYPE_SEPTAGE = 20;
   */
  SEPTAGE = 20,

  /**
   * Негабарит бункер
   *
   * @generated from enum value: WASTE_TYPE_OVERSIZED_BUNKER = 21;
   */
  OVERSIZED_BUNKER = 21,

  /**
   * Лом черного металла, Металл, Проволока стальная
   *
   * @generated from enum value: WASTE_TYPE_SCRAP_METAL = 22;
   */
  SCRAP_METAL = 22,

  /**
   * Макулатура
   *
   * @generated from enum value: WASTE_TYPE_PAPER = 23;
   */
  PAPER = 23,

  /**
   * Пленка б/у ПВД
   *
   * @generated from enum value: WASTE_TYPE_HDPE_FILM = 24;
   */
  HDPE_FILM = 24,

  /**
   * Мешки ПП, Отходы пластмасс ПП
   *
   * @generated from enum value: WASTE_TYPE_PP = 25;
   */
  PP = 25,

  /**
   * Отходы текстиля
   *
   * @generated from enum value: WASTE_TYPE_TEXTILE = 26;
   */
  TEXTILE = 26,

  /**
   * Шины
   *
   * @generated from enum value: WASTE_TYPE_TIRES = 27;
   */
  TIRES = 27,

  /**
   * Фильтрат завод
   *
   * @generated from enum value: WASTE_TYPE_LEACHATE = 28;
   */
  LEACHATE = 28,

  /**
   * Взвешивание ТС
   *
   * @generated from enum value: WASTE_TYPE_VEHICLE_WEIGHING = 29;
   */
  VEHICLE_WEIGHING = 29,

  /**
   * ПВД - полиэтилена высокого давления
   *
   * @generated from enum value: WASTE_TYPE_HIGH_DENSITY_POLYETHYLENE = 30;
   */
  HIGH_DENSITY_POLYETHYLENE = 30,

  /**
   * Лом и отходы из полиэтилентерефталата (Темные)
   *
   * @generated from enum value: WASTE_TYPE_DARK_PET_SCRAPS = 31;
   */
  DARK_PET_SCRAPS = 31,
}

/**
 * @generated from enum raccoonai.WasteType
 */
export type WasteTypeJson = "WASTE_TYPE_UNDEFINED" | "WASTE_TYPE_CONSTRUCTION" | "WASTE_TYPE_MSW" | "WASTE_TYPE_LIQUID" | "WASTE_TYPE_ORGANIC" | "WASTE_TYPE_LOW_DENSITY_POLYETHYLENE" | "WASTE_TYPE_BULKY" | "WASTE_TYPE_BALLAST" | "WASTE_TYPE_OVERSIZED" | "WASTE_TYPE_MIXED" | "WASTE_TYPE_CELLOPHANE" | "WASTE_TYPE_GLASS_CULLET" | "WASTE_TYPE_MEDICAL_AND_BIO" | "WASTE_TYPE_ALUMINUM_CANS" | "WASTE_TYPE_FLAKES" | "WASTE_TYPE_PET" | "WASTE_TYPE_PETRO_PRODUCTS" | "WASTE_TYPE_PRESSED_MSW" | "WASTE_TYPE_SORTED_MSW" | "WASTE_TYPE_NOT_SORTED_MSW" | "WASTE_TYPE_SEPTAGE" | "WASTE_TYPE_OVERSIZED_BUNKER" | "WASTE_TYPE_SCRAP_METAL" | "WASTE_TYPE_PAPER" | "WASTE_TYPE_HDPE_FILM" | "WASTE_TYPE_PP" | "WASTE_TYPE_TEXTILE" | "WASTE_TYPE_TIRES" | "WASTE_TYPE_LEACHATE" | "WASTE_TYPE_VEHICLE_WEIGHING" | "WASTE_TYPE_HIGH_DENSITY_POLYETHYLENE" | "WASTE_TYPE_DARK_PET_SCRAPS";

/**
 * Describes the enum raccoonai.WasteType.
 */
export const WasteTypeSchema: GenEnum<WasteType, WasteTypeJson> = /*@__PURE__*/
  enumDesc(file_enums, 30);

/**
 * Where a weighing stands: derived from whether its netto weight is recorded.
 *
 * @generated from enum raccoonai.ScaleRecordStatus
 */
export enum ScaleRecordStatus {
  /**
   * @generated from enum value: SCALE_RECORD_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * Brutto weighed, netto still to come.
   *
   * @generated from enum value: SCALE_RECORD_STATUS_IN_PROGRESS = 1;
   */
  IN_PROGRESS = 1,

  /**
   * Netto recorded.
   *
   * @generated from enum value: SCALE_RECORD_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,
}

/**
 * Where a weighing stands: derived from whether its netto weight is recorded.
 *
 * @generated from enum raccoonai.ScaleRecordStatus
 */
export type ScaleRecordStatusJson = "SCALE_RECORD_STATUS_UNDEFINED" | "SCALE_RECORD_STATUS_IN_PROGRESS" | "SCALE_RECORD_STATUS_COMPLETED";

/**
 * Describes the enum raccoonai.ScaleRecordStatus.
 */
export const ScaleRecordStatusSchema: GenEnum<ScaleRecordStatus, ScaleRecordStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 31);

/**
 * @generated from enum raccoonai.TruckEngineType
 */
export enum TruckEngineType {
  /**
   * @generated from enum value: TRUCK_ENGINE_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: TRUCK_ENGINE_TYPE_DIESEL = 1;
   */
  DIESEL = 1,

  /**
   * @generated from enum value: TRUCK_ENGINE_TYPE_PETROL = 2;
   */
  PETROL = 2,

  /**
   * @generated from enum value: TRUCK_ENGINE_TYPE_ELECTRIC = 3;
   */
  ELECTRIC = 3,

  /**
   * @generated from enum value: TRUCK_ENGINE_TYPE_HYBRID = 4;
   */
  HYBRID = 4,

  /**
   * Compressed Natural Gas
   *
   * @generated from enum value: TRUCK_ENGINE_TYPE_CNG = 5;
   */
  CNG = 5,
}

/**
 * @generated from enum raccoonai.TruckEngineType
 */
export type TruckEngineTypeJson = "TRUCK_ENGINE_TYPE_UNDEFINED" | "TRUCK_ENGINE_TYPE_DIESEL" | "TRUCK_ENGINE_TYPE_PETROL" | "TRUCK_ENGINE_TYPE_ELECTRIC" | "TRUCK_ENGINE_TYPE_HYBRID" | "TRUCK_ENGINE_TYPE_CNG";

/**
 * Describes the enum raccoonai.TruckEngineType.
 */
export const TruckEngineTypeSchema: GenEnum<TruckEngineType, TruckEngineTypeJson> = /*@__PURE__*/
  enumDesc(file_enums, 32);

/**
 * @generated from enum raccoonai.WhatsappOrderStatus
 */
export enum WhatsappOrderStatus {
  /**
   * @generated from enum value: WHATSAPP_ORDER_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: WHATSAPP_ORDER_STATUS_WELCOME = 1;
   */
  WELCOME = 1,

  /**
   * @generated from enum value: WHATSAPP_ORDER_STATUS_SELECTING_GROUP = 2;
   */
  SELECTING_GROUP = 2,

  /**
   * @generated from enum value: WHATSAPP_ORDER_STATUS_SELECTING_JOB_TYPE = 3;
   */
  SELECTING_JOB_TYPE = 3,

  /**
   * @generated from enum value: WHATSAPP_ORDER_STATUS_PENDING = 4;
   */
  PENDING = 4,

  /**
   * @generated from enum value: WHATSAPP_ORDER_STATUS_CONFIRMED = 5;
   */
  CONFIRMED = 5,

  /**
   * @generated from enum value: WHATSAPP_ORDER_STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,

  /**
   * @generated from enum value: WHATSAPP_ORDER_STATUS_EXPIRED = 7;
   */
  EXPIRED = 7,

  /**
   * Job type is fixed; the sender is asked for an optional comment for the
   * driver (how to enter the site, where the containers stand, ...) before
   * the confirmation prompt.
   *
   * @generated from enum value: WHATSAPP_ORDER_STATUS_AWAITING_COMMENT = 8;
   */
  AWAITING_COMMENT = 8,
}

/**
 * @generated from enum raccoonai.WhatsappOrderStatus
 */
export type WhatsappOrderStatusJson = "WHATSAPP_ORDER_STATUS_UNDEFINED" | "WHATSAPP_ORDER_STATUS_WELCOME" | "WHATSAPP_ORDER_STATUS_SELECTING_GROUP" | "WHATSAPP_ORDER_STATUS_SELECTING_JOB_TYPE" | "WHATSAPP_ORDER_STATUS_PENDING" | "WHATSAPP_ORDER_STATUS_CONFIRMED" | "WHATSAPP_ORDER_STATUS_CANCELLED" | "WHATSAPP_ORDER_STATUS_EXPIRED" | "WHATSAPP_ORDER_STATUS_AWAITING_COMMENT";

/**
 * Describes the enum raccoonai.WhatsappOrderStatus.
 */
export const WhatsappOrderStatusSchema: GenEnum<WhatsappOrderStatus, WhatsappOrderStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 33);

/**
 * Which telemetry a Моточасы (engine active hours) figure was derived from. Exposed so a
 * consumer can tell a measured figure from an absent one instead of reading 0 as "idle".
 *
 * @generated from enum raccoonai.EngineHoursSource
 */
export enum EngineHoursSource {
  /**
   * @generated from enum value: ENGINE_HOURS_SOURCE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * Integral of the ignition/engine-operation sensor over the shift window. Fleet-wide on
   * the Wialon Local orgs, and the preferred source.
   *
   * @generated from enum value: ENGINE_HOURS_SOURCE_IGNITION = 1;
   */
  IGNITION = 1,

  /**
   * Span of the cumulative CAN total_engine_hours counter. Only a handful of trucks carry a
   * genuine hour meter.
   *
   * @generated from enum value: ENGINE_HOURS_SOURCE_CAN_COUNTER = 2;
   */
  CAN_COUNTER = 2,

  /**
   * The shift has a window but no usable engine telemetry in it.
   *
   * @generated from enum value: ENGINE_HOURS_SOURCE_NONE = 3;
   */
  NONE = 3,
}

/**
 * Which telemetry a Моточасы (engine active hours) figure was derived from. Exposed so a
 * consumer can tell a measured figure from an absent one instead of reading 0 as "idle".
 *
 * @generated from enum raccoonai.EngineHoursSource
 */
export type EngineHoursSourceJson = "ENGINE_HOURS_SOURCE_UNDEFINED" | "ENGINE_HOURS_SOURCE_IGNITION" | "ENGINE_HOURS_SOURCE_CAN_COUNTER" | "ENGINE_HOURS_SOURCE_NONE";

/**
 * Describes the enum raccoonai.EngineHoursSource.
 */
export const EngineHoursSourceSchema: GenEnum<EngineHoursSource, EngineHoursSourceJson> = /*@__PURE__*/
  enumDesc(file_enums, 34);

/**
 * What a WhatsApp history message carries. Only text for now; polls, button
 * messages and other kinds come as new values.
 *
 * @generated from enum raccoonai.WhatsappMessageKind
 */
export enum WhatsappMessageKind {
  /**
   * @generated from enum value: WHATSAPP_MESSAGE_KIND_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: WHATSAPP_MESSAGE_KIND_TEXT = 1;
   */
  TEXT = 1,
}

/**
 * What a WhatsApp history message carries. Only text for now; polls, button
 * messages and other kinds come as new values.
 *
 * @generated from enum raccoonai.WhatsappMessageKind
 */
export type WhatsappMessageKindJson = "WHATSAPP_MESSAGE_KIND_UNDEFINED" | "WHATSAPP_MESSAGE_KIND_TEXT";

/**
 * Describes the enum raccoonai.WhatsappMessageKind.
 */
export const WhatsappMessageKindSchema: GenEnum<WhatsappMessageKind, WhatsappMessageKindJson> = /*@__PURE__*/
  enumDesc(file_enums, 35);

/**
 * Delivery of a dispatcher's message, from the send and Meta's status webhooks.
 * Numbered in delivery order: a message only moves forward. Unset on inbound
 * and bot messages.
 *
 * @generated from enum raccoonai.WhatsappMessageStatus
 */
export enum WhatsappMessageStatus {
  /**
   * @generated from enum value: WHATSAPP_MESSAGE_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: WHATSAPP_MESSAGE_STATUS_SENT = 1;
   */
  SENT = 1,

  /**
   * @generated from enum value: WHATSAPP_MESSAGE_STATUS_DELIVERED = 2;
   */
  DELIVERED = 2,

  /**
   * @generated from enum value: WHATSAPP_MESSAGE_STATUS_READ = 3;
   */
  READ = 3,

  /**
   * Refused at send time or failed later (e.g. outside the 24h window).
   *
   * @generated from enum value: WHATSAPP_MESSAGE_STATUS_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * Delivery of a dispatcher's message, from the send and Meta's status webhooks.
 * Numbered in delivery order: a message only moves forward. Unset on inbound
 * and bot messages.
 *
 * @generated from enum raccoonai.WhatsappMessageStatus
 */
export type WhatsappMessageStatusJson = "WHATSAPP_MESSAGE_STATUS_UNDEFINED" | "WHATSAPP_MESSAGE_STATUS_SENT" | "WHATSAPP_MESSAGE_STATUS_DELIVERED" | "WHATSAPP_MESSAGE_STATUS_READ" | "WHATSAPP_MESSAGE_STATUS_FAILED";

/**
 * Describes the enum raccoonai.WhatsappMessageStatus.
 */
export const WhatsappMessageStatusSchema: GenEnum<WhatsappMessageStatus, WhatsappMessageStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 36);

/**
 * Kind of an accounting document a provider's accounting system (1C) reports
 * back for the jobs it billed.
 *
 * @generated from enum raccoonai.AccountingDocumentKind
 */
export enum AccountingDocumentKind {
  /**
   * @generated from enum value: ACCOUNTING_DOCUMENT_KIND_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * «Реализация ТМЗ и услуг»: the sales document the act and the invoice are printed from.
   *
   * @generated from enum value: ACCOUNTING_DOCUMENT_KIND_REALIZATION = 1;
   */
  REALIZATION = 1,

  /**
   * АВР: act of completed works.
   *
   * @generated from enum value: ACCOUNTING_DOCUMENT_KIND_ACT = 2;
   */
  ACT = 2,

  /**
   * ЭСФ: electronic tax invoice (ИС ЭСФ).
   *
   * @generated from enum value: ACCOUNTING_DOCUMENT_KIND_ESF = 3;
   */
  ESF = 3,

  /**
   * Счёт на оплату: payment request.
   *
   * @generated from enum value: ACCOUNTING_DOCUMENT_KIND_INVOICE = 4;
   */
  INVOICE = 4,
}

/**
 * Kind of an accounting document a provider's accounting system (1C) reports
 * back for the jobs it billed.
 *
 * @generated from enum raccoonai.AccountingDocumentKind
 */
export type AccountingDocumentKindJson = "ACCOUNTING_DOCUMENT_KIND_UNDEFINED" | "ACCOUNTING_DOCUMENT_KIND_REALIZATION" | "ACCOUNTING_DOCUMENT_KIND_ACT" | "ACCOUNTING_DOCUMENT_KIND_ESF" | "ACCOUNTING_DOCUMENT_KIND_INVOICE";

/**
 * Describes the enum raccoonai.AccountingDocumentKind.
 */
export const AccountingDocumentKindSchema: GenEnum<AccountingDocumentKind, AccountingDocumentKindJson> = /*@__PURE__*/
  enumDesc(file_enums, 37);

/**
 * Lifecycle of an accounting document as the accounting system reports it.
 *
 * @generated from enum raccoonai.AccountingDocumentStatus
 */
export enum AccountingDocumentStatus {
  /**
   * @generated from enum value: ACCOUNTING_DOCUMENT_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * created, not posted
   *
   * @generated from enum value: ACCOUNTING_DOCUMENT_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * проведён
   *
   * @generated from enum value: ACCOUNTING_DOCUMENT_STATUS_POSTED = 2;
   */
  POSTED = 2,

  /**
   * sent to the counterparty or to ИС ЭСФ
   *
   * @generated from enum value: ACCOUNTING_DOCUMENT_STATUS_SENT = 3;
   */
  SENT = 3,

  /**
   * accepted by the counterparty
   *
   * @generated from enum value: ACCOUNTING_DOCUMENT_STATUS_SIGNED = 4;
   */
  SIGNED = 4,

  /**
   * @generated from enum value: ACCOUNTING_DOCUMENT_STATUS_REJECTED = 5;
   */
  REJECTED = 5,

  /**
   * @generated from enum value: ACCOUNTING_DOCUMENT_STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,
}

/**
 * Lifecycle of an accounting document as the accounting system reports it.
 *
 * @generated from enum raccoonai.AccountingDocumentStatus
 */
export type AccountingDocumentStatusJson = "ACCOUNTING_DOCUMENT_STATUS_UNDEFINED" | "ACCOUNTING_DOCUMENT_STATUS_DRAFT" | "ACCOUNTING_DOCUMENT_STATUS_POSTED" | "ACCOUNTING_DOCUMENT_STATUS_SENT" | "ACCOUNTING_DOCUMENT_STATUS_SIGNED" | "ACCOUNTING_DOCUMENT_STATUS_REJECTED" | "ACCOUNTING_DOCUMENT_STATUS_CANCELLED";

/**
 * Describes the enum raccoonai.AccountingDocumentStatus.
 */
export const AccountingDocumentStatusSchema: GenEnum<AccountingDocumentStatus, AccountingDocumentStatusJson> = /*@__PURE__*/
  enumDesc(file_enums, 38);

/**
 * Platform entity an external system keeps its own reference for.
 *
 * @generated from enum raccoonai.IntegrationEntityType
 */
export enum IntegrationEntityType {
  /**
   * @generated from enum value: INTEGRATION_ENTITY_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: INTEGRATION_ENTITY_TYPE_ORGANIZATION = 1;
   */
  ORGANIZATION = 1,

  /**
   * @generated from enum value: INTEGRATION_ENTITY_TYPE_CONTRACT = 2;
   */
  CONTRACT = 2,
}

/**
 * Platform entity an external system keeps its own reference for.
 *
 * @generated from enum raccoonai.IntegrationEntityType
 */
export type IntegrationEntityTypeJson = "INTEGRATION_ENTITY_TYPE_UNDEFINED" | "INTEGRATION_ENTITY_TYPE_ORGANIZATION" | "INTEGRATION_ENTITY_TYPE_CONTRACT";

/**
 * Describes the enum raccoonai.IntegrationEntityType.
 */
export const IntegrationEntityTypeSchema: GenEnum<IntegrationEntityType, IntegrationEntityTypeJson> = /*@__PURE__*/
  enumDesc(file_enums, 39);

